/* eslint-disable react/jsx-no-target-blank */
import React from "react"
import cn from "classnames"
import { FacebookFill, Pinterest } from "@/skylticons"
import env from "@/common/env"
import useMedia from "@/common/hooks/use_media"

const buttonStyle = {
  margin: "0 3px",
  cursor: "pointer",
  display: "inline-block",
}

const fbColor = { color: "#3C5896" }
const pinterestColor = { color: "#CA282F" }

interface SignShareProps {
  sharePath: string
  skeleton?: boolean
}

const SignShare: React.FC<SignShareProps> = ({ sharePath, skeleton }) => {
  const fbLink = `${env.languageSegment}${sharePath}?platform=facebook`
  const pinLink = `${env.languageSegment}${sharePath}?platform=pinterest`

  const desktop = useMedia("(min-width: 1215px)")

  return (
    <div className="sign-share center">
      <a
        className={cn("facebook", { skeleton })}
        href={fbLink}
        target="_blank"
        rel="noopener"
        style={{ ...buttonStyle, ...fbColor }}
      >
        <FacebookFill width={desktop ? 24 : 16} />
      </a>
      <a
        className={cn("pinterest", { skeleton })}
        href={pinLink}
        target="_blank"
        rel="noopener"
        style={{ ...buttonStyle, ...pinterestColor }}
      >
        <Pinterest viewBox="0 0 448 512" width={desktop ? 20 : 14} />
      </a>
    </div>
  )
}

export default SignShare
